import { useTranslation } from "react-i18next";
import AuthPageShell from "../components/AuthPageShell";
import LoginForm from "../components/LoginForm";

const LoginPage = () => {
  const { t } = useTranslation("auth");

  return (
    <AuthPageShell title={t("login.title")} subtitle={t("login.subtitle")}>
      <LoginForm />
    </AuthPageShell>
  );
};

export default LoginPage;
